import { BlogTranscribingStatusEnum } from '@ztechapps/common.contract'

/**
 * Human-readable labels for blog transcription statuses
 */
export const BLOG_TRANSCRIPTION_STATUS_LABELS: Record<BlogTranscribingStatusEnum, string> = {
  [BlogTranscribingStatusEnum.idle]: 'Ready',
  [BlogTranscribingStatusEnum.waiting]: 'Queued',
  [BlogTranscribingStatusEnum.active]: 'Processing',
  [BlogTranscribingStatusEnum.delayed]: 'Delayed',
  [BlogTranscribingStatusEnum.completed]: 'Completed',
  [BlogTranscribingStatusEnum.failed]: 'Failed',
  [BlogTranscribingStatusEnum.cancelled]: 'Cancelled',
}

/**
 * Statuses that indicate transcription is currently in progress
 */
export const IN_PROGRESS_STATUSES: BlogTranscribingStatusEnum[] = [
  BlogTranscribingStatusEnum.waiting,
  BlogTranscribingStatusEnum.active,
  BlogTranscribingStatusEnum.delayed,
]

/**
 * Statuses that allow cancellation
 * Note: 'active' is intentionally excluded as active jobs cannot be cancelled
 */
export const CANCELLABLE_STATUSES: BlogTranscribingStatusEnum[] = [
  BlogTranscribingStatusEnum.waiting,
  BlogTranscribingStatusEnum.delayed,
]

/**
 * Check if a status indicates transcription is in progress
 *
 * @param status - The status to check
 * @returns True if status is waiting, active, or delayed
 */
export function isStatusInProgress(status?: BlogTranscribingStatusEnum | string): boolean {
  if (!status) {
    return false
  }
  return IN_PROGRESS_STATUSES.includes(status as BlogTranscribingStatusEnum)
}

/**
 * Check if a status allows cancellation
 *
 * @param status - The status to check
 * @returns True if status is waiting or delayed (active jobs cannot be cancelled)
 */
export function isStatusCancellable(status?: BlogTranscribingStatusEnum | string): boolean {
  if (!status) {
    return false
  }
  return CANCELLABLE_STATUSES.includes(status as BlogTranscribingStatusEnum)
}

/**
 * Get human-readable label for a transcription status
 *
 * @param status - The status to get label for
 * @returns Human-readable status label
 */
export function getStatusLabel(status: BlogTranscribingStatusEnum): string {
  return BLOG_TRANSCRIPTION_STATUS_LABELS[status]
}
